import { FC } from 'react'
import s from './CheckoutInputError.module.scss'
interface CheckoutInputErrorProps {
  message: string
}
const CheckoutInputError: FC<CheckoutInputErrorProps> = ({ message }) => {
  return <p className={s.error}>{message}</p>
}

export default CheckoutInputError
